import {AttributeLink} from '@acng/frontend-stargazer';
import {incomplete, index, path} from '@acng/frontend-voyager';
import {getState} from '../context/state.js';

/**
 * TODO Rename into 'state-sticky', 'state-match'
 * @group DOM Attribute
 */
const attributeName = 'route-path';

AttributeLink(attributeName, (element, value) => () => {
  const route = getState(element);
  // "/" am ende ist NICHT incomplete, nur "/" ist index

  if (value == '/') {
    route.config(index);
  }

  if (/[^\/]$/.test(value)) {
    route.config(incomplete);
  }

  route.config(path(value));
});

export {attributeName as ROUTE_PATH};
